export function formatMessagePayload(messages) {
  if (messages == null) return "";

  if (typeof messages === "string") {
    try {
      return JSON.stringify(JSON.parse(messages), null, 2);
    } catch {
      return messages;
    }
  }

  return JSON.stringify(messages, null, 2);
}
